/*
 * @Author: 右侧内容重构
 * @Date:   2017-09-11 16:07:27
 * @Last Modified by:   fang.lijuan
 * @Last Modified time: 2017-12-17 16:29:05
 */

'use strict';
angular.module('shareDetailModule', [])
    .directive('shareDetail', ['$state', '$q', '$location', '$timeout', '$sce', '$stateParams', 'trsspliceString', 'resourceCenterService', 'resCtrModalService', 'modalDialog', 'trsHttpService', 'storageListenerService', 'previewService',
        function($state, $q, $location, $timeout, $sce, $stateParams, trsspliceString, resourceCenterService, resCtrModalService, modalDialog, trsHttpService, storageListenerService, previewService) {
            // Runs during compile
            return {
                scope: {
                    rebuildData: '=',
                },
                restrict: 'AE',
                transclude: {
                    'right': '?rightBtn',
                },
                templateUrl: './resourceCenter/shared/quickPreview/detail/detail_tpl.html',
                replace: true,
                link: function(scope, iElm, iAttrs, controller) {
                    initStatus();
                    initData();

                    /**
                     * [initStatus description]初始化状态
                     * @return {[type]} [description]
                     */
                    function initStatus() {
                        scope.videos = [];
                        scope.status = {
                            methodname: {
                                1: 'getNewsDoc',
                                2: 'getPicsDoc',
                                4: 'getLinkDoc',
                                5: '',
                                6: '',
                                7: 'getVideoDoc'
                            },
                            atlas: false,
                            isUGC: $stateParams.isugc == '1',
                        };
                        scope.data = {
                            keywordsArray: [], // 关键词数组
                            nodeid: $stateParams.nodeid
                        };
                        if (scope.rebuildData.type == 8) {
                            scope.params = {
                                'serviceid': 'mlf_fusioncreate',
                                'methodname': 'getAPPFusionDoc',
                                'sourceDocId': scope.rebuildData.metaDataId
                            };
                        } else {
                            scope.params = {
                                'serviceid': 'mlf_myrelease',
                                'methodname': scope.status.methodname[scope.rebuildData.type],
                                'MetaDataId': scope.rebuildData.metaDataId
                            };
                        }


                    }

                    /**
                     * [initData description] 初始化数据
                     * @return {[type]} [description]
                     */
                    function initData() {
                        if (scope.status.isUGC) {
                            scope.params = {
                                serviceid: 'mlf_ugc',
                                methodname: 'queryArticles',
                                Method: 'articleInfo',
                                ID: scope.rebuildData.metaDataId
                            };
                        }
                        scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), scope.params, 'get').then(function(data) {
                            if (scope.status.isUGC) {
                                if (data.success) {
                                    scope.detailData = data.data[0].article;
                                    scope.detailData.METADATAID = data.data[0].article.id;
                                    scope.detailData.DOCTYPEID = '1';
                                    scope.detailData.TITLE = data.data[0].article.articleTitle;
                                    scope.detailData.shareUser = data.data[0].article.cruser;
                                    scope.detailData.DOCWORDSCOUNT = data.data[0].article.articleWordsCount;
                                    scope.detailData.HTMLCONTENT = data.data[0].article.articleHtmlCon;
                                    scope.status.audioVideoidsArray = data.data[0].videoUrlList.concat(data.data[0].audioUrlList);
                                    angular.forEach(scope.status.audioVideoidsArray, function(value, key) {
                                        value.AUDIOVIDEOID = value.qiniuId;
                                        value.STORAGE = '2';
                                    });
                                }
                            } else {
                                scope.detailData = data;
                                scope.data.keywordsArray = !data.KEYWORDS ? [] : data.KEYWORDS.split(';');
                                scope.status.doctype = data.DOCTYPEID;
                                scope.detailData.shareUser = scope.rebuildData.shareUser;
                                if (data.DOCTYPEID == 7) {
                                    getVideoUrl(data);
                                }
                                getShareCounts(data);
                            }

                        });
                    }

                    /**
                     * [getShareCounts description] 获取分享次数
                     * @param   {[object]}  item  [item description] 稿件信息
                     * @return  {[type]}          [return description]
                     */
                    function getShareCounts(item) {
                        var params = {
                            serviceid: 'mlf_releaseSource',
                            methodname: 'queryGroupIssuedCounts',
                            MetaDataIds: item.METADATAID
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            scope.detailData.shareCounts = data[item.METADATAID];
                        });
                    }

                    /**
                     * [getVideoUrl description] 获取视频链接
                     * @param   {[object]}  data  [data description] 视频信息
                     * @return  {[type]}          [return description]
                     */
                    function getVideoUrl(data) {
                        var params = {
                            serviceid: 'mlf_videoInterfacesEncapsulation',
                            methodname: 'getVideoInfoAndUpdate',
                            audioVideoId: data.VIDEOREL[0].AUDIOVIDEOID,
                            plateFormFlag: 'BDVideoObject',
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            scope.videos[0] = {
                                type: 'video',
                                videoId: data.videoId,
                                info: '',
                                src: $sce.trustAsResourceUrl(data.videoUrl),
                                filename: data.filename
                            };
                        });
                        // previewService.getAudioVideoPlayer(data.VIDEOREL[0].AUDIOVIDEOID, 'video/mp4').then(function(item) {
                        //     scope.videos[0] = {
                        //         type: 'video',
                        //         id: data.VIDEOREL[0].AUDIOVIDEOID,
                        //         info: '',
                        //         src: $sce.trustAsResourceUrl(item.DATA.videoUrl),
                        //         filename: item.DATA.filename
                        //     };
                        // });
                    }

                    /**
                     * [openTakeDraftModal description] 取稿
                     * @return {[type]} [description]
                     */
                    scope.openTakeDraftModal = function() {
                        var params = {};
                        if (scope.status.isUGC) {
                            params = {
                                serviceid: 'mlf_ugc',
                                methodname: 'takeArticle',
                                Method: 'takeArticle',
                                ID: scope.rebuildData.metaDataId,
                                SourceName: '资源中心-共享稿库-' + scope.detailData.SOURCENAME
                            };
                        } else {
                            params = {
                                serviceid: 'mlf_releasesource',
                                methodname: 'fetch',
                                MetaDataIds: scope.rebuildData.metaDataId,
                                SourceName: '资源中心-共享稿库-' + scope.detailData.SOURCENAME,
                                nodeid: $stateParams.nodeid
                            };
                        }
                        setTakeDraftItems().then(function() { // 为了特殊处理提交微博渠道，而加的方法
                            var modalInstance = resCtrModalService.fullTakeDraft(params, true, [scope.detailData], scope.status.isUGC);
                            modalInstance.result.then(function() {
                                storageListenerService.addListenerToResource('takeDraft');
                            });
                        });
                    };

                    /**
                     * [setTakeDraftItems description] 处理取稿弹窗所需要的“稿件信息”参数
                     * @return  {[type]}  [return description]
                     */
                    function setTakeDraftItems() {
                        var deffer = $q.defer();
                        if (scope.detailData.relatedMedias) {
                            deffer.resolve();
                        } else {
                            getBindingMediaIds().then(function(data) {
                                scope.detailData.relatedMedias = data;
                                deffer.resolve();
                            });
                        }
                        return deffer.promise;
                    }

                    /**
                     * [getBindingMediaIds description] 获取绑定的渠道的相关id
                     * @param {[type]} [metadataid] [description] iwo稿件id
                     * @return {[type]} [description]
                     */
                    function getBindingMediaIds() {
                        var defer = $q.defer();
                        var params = {
                            serviceid: 'mlf_fusioncreate',
                            methodname: 'queryFuseMappings',
                            sourceDocId: scope.rebuildData.metaDataId,
                            mediaTypes: ''
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            defer.resolve(data);
                        });
                        return defer.promise;
                    }

                    /**
                     * [creationAxis description] 个人素材
                     * @return {[type]} [description]
                     */
                    scope.creationAxis = function() {
                        var params = {
                            'serviceid': 'mlf_releaseSource',
                            'methodname': 'addPersonalMaterialOfTxt',
                            'PersonalMaterialId': '0',
                            'MetaDataId': scope.rebuildData.metaDataId
                        };
                        resourceCenterService.setBigDataCreation(params).then(function(data) {
                            modalDialog.alertType('添加成功', '', 'success', false);
                        });
                    };

                    /**
                     * [collect description] 收藏
                     * @return {[type]} [description]
                     */
                    scope.collect = function() {
                        var params;
                        if (scope.status.isUGC === true) {
                            params = {
                                serviceid: 'mlf_ugc',
                                methodname: 'collectUgcDoc',
                                Method: 'articleInfo',
                                ID: scope.rebuildData.metaDataId
                            };
                        } else {
                            params = {
                                'serviceid': 'mlf_myrelease',
                                'methodname': 'collect',
                                'MetaDataIds': scope.rebuildData.metaDataId
                            };
                        }
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                            modalDialog.alertType('收藏成功!', '', 'success', false, '');
                        });
                    };

                    /**
                     * [plainView description] 普通视图
                     * @return {[type]} [description]
                     */
                    scope.plainView = function() {
                        $state.go('front.resourcectrl.share.resource', $stateParams);
                    };
                }
            };
        }
    ]);
